export default __webpack_public_path__ + "static/nursing_carousel_2-b0926e3451b2882d50d997a872c365b1.jpg";